module.exports = __webpack_public_path__ + "02_short_gray.73690a24.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/02_short_gray.png
// module id = r0lI
// module chunks = 0